import { useState } from 'react';
import { s2t, t2s } from '../data/simplified-traditional';
import './ToolStyles.css';

type Mode = 's2t' | 't2s';

const ChineseConverter = () => {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [mode, setMode] = useState<Mode>('s2t');

    const convert = () => {
        const map = mode === 's2t' ? s2t : t2s;
        const result = input
            .split('')
            .map((char) => map[char] || char)
            .join('');
        setOutput(result);
    };

    return (
        <div className="tool-container">
            <div className="button-group">
                <button
                    className={`mode-button ${mode === 's2t' ? 'active' : ''}`}
                    onClick={() => { setMode('s2t'); setOutput(''); }}
                >
                    简体 → 繁体
                </button>
                <button
                    className={`mode-button ${mode === 't2s' ? 'active' : ''}`}
                    onClick={() => { setMode('t2s'); setOutput(''); }}
                >
                    繁体 → 简体
                </button>
            </div>

            <div className="input-group">
                <label className="input-label">
                    {mode === 's2t' ? '输入简体中文' : '输入繁体中文'}
                </label>
                <textarea
                    className="tool-textarea"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    rows={6}
                    placeholder={mode === 's2t' ? '输入简体中文文本...' : '輸入繁體中文文本...'}
                />
            </div>

            <button className="tool-button primary" onClick={convert}>
                转换
            </button>

            {output && (
                <div className="output-group">
                    <div className="output-header">
                        <label className="output-label">结果</label>
                        <button
                            className="copy-button"
                            onClick={() => navigator.clipboard.writeText(output)}
                        >
                            复制
                        </button>
                    </div>
                    <div className="tool-output">{output}</div>
                </div>
            )}
        </div>
    );
};

export default ChineseConverter;
